import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultarConsistenciaBiometricaState } from './types';

export const INITIAL_STATE: ConsultarConsistenciaBiometricaState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarConsistenciaBiometricaState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_CONSISTENCIA_BIOMETRICA_REQUEST: {
				break;
			}
			case Types.CONSULTAR_CONSISTENCIA_BIOMETRICA_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTAR_CONSISTENCIA_BIOMETRICA_FAILURE: {
				draft.status = action.payload.data.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTAR_CONSISTENCIA_BIOMETRICA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
